<script>
import { cn } from "$lib/utils";

import { Icon } from "../icons";

let copyButton;
let showCheckmark = false;

function handleClick() {
  const preTagSibling = copyButton.nextElementSibling;

  navigator.clipboard.writeText(preTagSibling.innerText);

  showCheckmark = true;

  setTimeout(() => (showCheckmark = false), 1000);
}

const btnClass = cn(
  "absolute",
  "right-3",
  "top-3",
  "rounded-md",
  "p-1",
  "shadow-md",
  showCheckmark ? "bg-green-900" : "bg-gray-700 hover:bg-gray-600",
);
</script>

<button bind:this={copyButton} on:click={handleClick} class={btnClass}>
  {#if showCheckmark}
    <Icon name="Check" class="h-6 w-6 fill-green-300" />
  {:else}
    <Icon name="Copy" class="h-6 w-6 fill-white" />
  {/if}
</button>
